export const CREATE_LIST_MODULE_ID = 'create-list-module';
export const CREATE_LIST_MODULE = () => import('@capital-access/lists/actions').then(m => m.CreateListModule);
